import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  InputAdornment,
  Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormField from "components/FormField";
import MDButton from "components/MDButton";
import { toast } from "react-toastify";
import MDBox from "components/MDBox";
import { URL_API } from "config";
import axios from "axios";

const CooperatedFormAddress = ({
  label,
  cooperated,
  street,
  setStreet,
  state,
  setState,
  neighborhood,
  setNeighborhood,
  city,
  setCity,
  setInput,
}) => {
  const [step, setStep] = useState(false);
  const [getCepLoad, setGetCepLoad] = useState(false);

  const tag = localStorage.getItem("Tag");

  useEffect(() => {
    (async () => {
      try {
        if (cooperated?.cep) {
          const response = await axios.get(
            `${URL_API}/cep?cep=${cooperated?.cep.replace(
              /[^a-zA-Z0-9]/g,
              ""
            )}`,
            {
              headers: {
                Authorization: `Bearer ${tag}`,
              },
            }
          );

          setStreet(response?.data.street);
          setState(response?.data.state);
          setNeighborhood(response?.data.neighborhood);
          setCity(response?.data.city);
        }
      } catch (e) {
        toast.error(e.response.data);
      }
    })();
    // eslint-disable-next-line
  }, [getCepLoad]);

  return (
    <Accordion
      expanded={step}
      onChange={() => setStep(!step)}
      slotProps={{ transition: { timeout: 400 } }}
      sx={{
        "& .MuiAccordion-region": {
          height: step ? "auto" : 0,
        },
        "& .MuiAccordionDetails-root": {
          display: step ? "block" : "none",
        },
      }}
    >
      <MDBox p={3}>
        <MDBox>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography>{label}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MDBox mt={1.625}>
              <FormField
                type="text"
                label="CEP"
                name="cep"
                value={cooperated?.cep}
                mask="CEP"
                placeholder="CEP"
                onChange={setInput}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" style={{ outline: "none" }}>
                      <MDButton
                        variant="gradient"
                        color="light"
                        size="small"
                        onClick={() => setGetCepLoad(!getCepLoad)}
                      >
                        buscar
                      </MDButton>
                    </InputAdornment>
                  ),
                }}
              />
              <FormField
                type="text"
                label="Rua"
                name="street"
                value={street}
                placeholder="Rua"
                fieldShrink
                onChange={(e) => setStreet(e.target.value)}
                required
              />
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Número"
                    name="number"
                    value={cooperated?.number}
                    placeholder="Número"
                    onChange={setInput}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Complementos"
                    name="complement"
                    value={cooperated?.complement}
                    placeholder="Complementos"
                    onChange={setInput}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="UF"
                    name="state"
                    value={state}
                    placeholder="UF"
                    fieldShrink
                    onChange={(e) => setState(e.target.value)}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Bairro"
                    name="neighborhood"
                    value={neighborhood}
                    placeholder="Bairro"
                    fieldShrink
                    onChange={(e) => setNeighborhood(e.target.value)}
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Cidade"
                    name="city"
                    value={city}
                    placeholder="Cidade"
                    fieldShrink
                    onChange={(e) => setCity(e.target.value)}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Endereço de Correspondência"
                    name="mailing_address"
                    value={cooperated?.mailing_address}
                    placeholder="Endereço de Correspondência"
                    onChange={setInput}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </AccordionDetails>
        </MDBox>
      </MDBox>
    </Accordion>
  );
};

export default CooperatedFormAddress;
